import React, { useState } from "react";
import { Modal, Button, Form, Input, Radio, message } from "antd";
import { KEYS, KEYS_TEST } from "./index";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ mode, detail, getData }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const modalTitle = mode === "create" ? "新增角色" : "编辑角色";
  const operationText = mode === "create" ? "新增角色" : "编辑角色";

  return (
    <>
      {mode === "create" && (
        <Button
          type="primary"
          onClick={() => {
            form.resetFields();
            setVisible(true);
          }}
        >
          {operationText}
        </Button>
      )}
      {mode === "edit" && (
        <a
          onClick={() => {
            form.resetFields();
            setVisible(true);
            form.setFieldsValue(detail);
          }}
        >
          编辑
        </a>
      )}

      <Modal
        title={modalTitle}
        open={visible}
        onCancel={() => {
          setVisible(false);
        }}
        onOk={() => {
          // 提交表单
          form
            .validateFields()
            .then((values) => {
              axios
                .post(`${localhost}/manage/role/save`, {
                  ...(detail || {}),
                  ...values,
                })
                .then((res) => {
                  message.success(
                    `${mode === "edit" ? "编辑" : "新增"}角色成功！`
                  );
                  setVisible(false);
                  getData();
                  form.resetFields();
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((err) => {
              console.log("err", err);
            });
        }}
      >
        <Form
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          form={form}
          name="create-role"
        >
          <Form.Item
            label={KEYS_TEST[KEYS.ROLE_NAME]}
            name={KEYS.ROLE_NAME}
            required
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={KEYS_TEST[KEYS.ROLE_CODE]}
            name={KEYS.ROLE_CODE}
            required
          >
            <Input />
          </Form.Item>
          <Form.Item label={KEYS_TEST[KEYS.REMARK]} name={KEYS.REMARK}>
            <Input />
          </Form.Item>
          <Form.Item label={KEYS_TEST[KEYS.ENABLE]} name={KEYS.ENABLE} required>
            <Radio.Group>
              <Radio value={1}>是</Radio>
              <Radio value={2}>否</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={KEYS_TEST[KEYS.SOURCE]} name={KEYS.SOURCE} required>
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
